import { useEffect, useState } from "react";
import { createBoqApi, updateBoqApi } from "../../services/api/boq/boqService";

export default function BoqModal({
  open,
  onClose,
  projectId,
  boq,
  onSaved,
}) {
  const [form, setForm] = useState({
    boq_name: "",
    discipline: "",
    status: "draft",
  });

  const [loading, setLoading] = useState(false);
  const isEdit = Boolean(boq);

  useEffect(() => {
    if (boq) {
      setForm({
        boq_name: boq.boq_name || "",
        discipline: boq.discipline || "",
        status: boq.status || "draft",
      });
    } else {
      setForm({ boq_name: "", discipline: "", status: "draft" });
    }
  }, [boq]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.boq_name || !form.discipline) {
      alert("BOQ Name and Discipline are required");
      return;
    }

    setLoading(true);
    try {
      if (isEdit) {
        await updateBoqApi(boq.id, form);
      } else {
        await createBoqApi({
          project_id: projectId,
          boq_name: form.boq_name,
          discipline: form.discipline,
        });
      }

      onSaved();     // refresh BOQ list
      onClose();     // close modal
    } catch (err) {
      console.error(err);
      alert("Failed to save BOQ");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-full max-w-md p-6 shadow">
        <h3 className="text-lg font-semibold mb-4">
          {isEdit ? "Edit BOQ" : "Create BOQ"}
        </h3>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium">BOQ Name *</label>
            <input
              name="boq_name"
              value={form.boq_name}
              onChange={handleChange}
              className="w-full border p-2 rounded"
            />
          </div>

          <div>
            <label className="text-sm font-medium">Discipline *</label>
            <input
              name="discipline"
              value={form.discipline}
              onChange={handleChange}
              className="w-full border p-2 rounded"
            />
          </div>

          {isEdit && (
            <div>
              <label className="text-sm font-medium">Status</label>
              <select
                name="status"
                value={form.status}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              >
                <option value="draft">Draft</option>
                <option value="approved">Approved</option>
              </select>
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
